// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7f5389e0","198":"a5e53194","404":"36959dcd","498":"0555875b"}[chunkId] + ".chunk.js";
};